<template>
  <LayoutHeader class="layout-header">
    <span @click="toggleCollapsed" class="layout-header-trigger">
      <MenuUnfoldOutlined v-if="getCollapsed" />
      <MenuFoldOutlined v-else />
    </span>

    <User />
  </LayoutHeader>
  <!-- <Content></Content> -->
</template>
<script lang="ts" setup>
import { LayoutHeader } from 'ant-design-vue';

import User from '../user/index.vue';
import { MenuUnfoldOutlined, MenuFoldOutlined } from '@ant-design/icons-vue';
// import Content from "../content/index.vue";
import { useMenuSetting } from '/@/hooks/setting/useMenuSetting';
const { getCollapsed, toggleCollapsed } = useMenuSetting();
</script>
<style lang="less" scoped>
.layout-header {
  line-height: 48px;
  display: flex;
  background-color: #fff;
  height: 48px;
  padding: 0;
  line-height: 48px;
  align-items: center;
  justify-content: space-between;
  color: @text-color-base;
  border-left: 1px solid @border-color-light;
  border-bottom: 1px solid @border-color-light;
}
.layout-header-trigger {
  display: flex;
  height: 100%;
  cursor: pointer;
  align-items: center;
  padding: 0 10px 0 !important;
}
[data-theme='dark'] .layout-header {
  background: #151515;
}
</style>
